import React, { useEffect, useState } from "react";
import styles from "./feedCreatePost.module.scss";
import { KoButton, KoDate, KoForm, KoFormBuilder, KoLoader, KoModal, KoNano, KoPopOver, KoRichTextEditor, KoSelect, KoStaicMembers, KoText, KoTimePicker, KoToast, KoTooltips, KoUpload, KoUserSelect } from "packages";
import KoIcon from "@kwapio/icons";
import { OrgAPI } from "pages/organization/org.service";
import { FeedAPI } from "./feed.service";
import { getCookie } from "shared/utils/cookies";
import FeedAttachments from "./feedAttachments";

export default function FeedCreatePost({ user, getFeeds, postId }) {
  const [createPost, setCreatePost] = React.useState(false);
  const [users, setDataList] = useState();
  const [groups, setGroupsData] = useState([]);
  const [form] = KoForm.useForm();
  const [currentPost, setCurrentPost] = useState({});
  const [scheduleForm] = KoForm.useForm();
  const [openSchedule, setOpenSchedule] = useState(false);

  const [isLoading, setLoading] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [uploadFileModal, setUploadFileModal] = useState(false);
  const [, setCurrentFile] = useState();
  const [isPollModal, setPollModal] = useState(false);
  const [feedId] = useState(KoNano('FED'));
  const [pagination ] = useState({
    size: 100000,
    offset: 0,
    page: 1
  });


  useEffect(() => {
    getContacts(pagination);
    getGroups();
  }, []);

  useEffect(() => {
    if (postId) {
      FeedAPI.getFeedById(postId).then((data) => {
        setCurrentPost(data);
      });
    }
  }, [postId]);

  const getContacts = async(q) => {
    setLoading(true);
    OrgAPI.getOrgUsers(q).then(
      (data) => {
        setDataList();
        setLoading(false);
        setDataList(data['users']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const getGroups = async(q) => {
    setLoading(true);
    OrgAPI.getOrgGroups(q).then(
      (data) => {
        setGroupsData();
        setLoading(false);
        setGroupsData(data['groups']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleFinish = (values) => {
    setLoading(true);
    currentPost['feedType'] = 'feed';
    values['feedId']= currentPost?.feedId ? currentPost?.feedId : feedId;
    FeedAPI.postFeed({ ...values, users: selectedUsers, groups: selectedGroups, ...currentPost }).then(
      (data) => {
        setLoading(false);
        setCreatePost(false);
        getFeeds && getFeeds();
        form.resetFields();
        scheduleForm.resetFields();
        KoToast.success("Post created successfully");
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleScheduleFinish = (values) => {
    values['isScheduled'] = true;
    setCurrentPost(values);
    setOpenSchedule(false);
  };

  const extractUrl = (file) => {
    if (Array.isArray(file.response)) {
      return file.response[0];
    }
    if (file.response?.url) return file.response.url;
    if (file.response?.data?.url) return file.response.data.url;
    return file.url;
  };

  const props = {
    name: 'files',
    multiple: true,
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    data: { module: 'feed', lookupId: currentPost?.feedId ? currentPost?.feedId : feedId },
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },
  
    onChange(info) {
      setLoading(true);
      if (info.file.status !== 'uploading') {
      }
      const { fileList } = info;
      const allFinished = fileList.every(
        file => file.status === 'done' || file.status === 'error'
      );
      if (allFinished) {
        setLoading(false);

        const successfulFiles = fileList
          .filter(file => file.status === 'done')
          .map(file => {
            const url = extractUrl(file);

            return {
              name: file.name,
              type: file.type,
              size: file.size,
              uid: file.uid,
              url,
              lastModifiedDate: file.lastModifiedDate || new Date().toISOString()
            };
          });

        updateTicektInfo(successfulFiles);
      }
      else if (info.file.status === 'error') {
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  const Description = ({ value, onChange }) =>
    <KoRichTextEditor
      placeholder='What do you want to talk about?'
      initialValues={value}
      name='text'
      form={form}
      lookupId={currentPost?.feedId ? currentPost?.feedId : feedId}
      isFeed={true}
      isToolbar={false}
      onSetEditorValues={v => onChange(v)}/>;


  const updateTicektInfo = (info) => {
    const oldFiles = Array.isArray(currentPost?.attachments)
      ? currentPost.attachments
      : [];
    const newFiles = Array.isArray(info)
      ? info
      : [];
    const uniqueFiles = [...oldFiles, ...newFiles].reduce((acc, file) => {
      if (!acc.some(f => f.uid === file.uid)) acc.push(file);
      return acc;
    }, []);
    form.setFieldsValue({ attachments: uniqueFiles });
  };

  const TASKINFOMETADATA = {
    columns: 6,
    formItemLayout: null,
    initialValues: currentPost,
    colon: true,
    fields: [
      {
        key: 'text', placeholder: 'What do you want to talk about?', colSpan: 6,
        widget: Description
      },
      {
        key: 'attachments', placeholder: 'What do you want to talk about?', colSpan: 6,className: 'metaFieldHide'
      }
    ]
  };

  const Date = ({ value, onChange }) => {

    return (
      <KoDate
        value={value}
        format={'DD-MMM-YYYY'}
        daysAgo={0}
        onChange={v => onChange(v)}
      />
    );
  };

  const Time = ({ value, onChange }) => {
    const handleChange = (v) => {
      const formattedValue = v instanceof Date ? v.toTimeString().slice(0, 5) : v;
      onChange(formattedValue);
    };
  
    const formattedValue = value ? (value instanceof Date ? value.toTimeString().slice(0, 5) : value) : '';
  
    return (
      <KoTimePicker
        changeOnScroll
        needConfirm={false}
        allowClear={false}
        value={formattedValue}
        format='HH:mm A'
        onChange={handleChange}
      />
    );
  };

  const SCHDULEDATA = {
    columns: 6,
    formItemLayout: null,
    initialValues: currentPost,
    colon: true,
    fields: [
      {
        key: 'schedule.date', placeholder: 'Date', label: 'Date',
        colSpan: 3, widget: Date, rules: [
          {
            required: true,
            message: 'Please select start date.'
          }
        ]
      },
      {
        key: 'schedule.time', placeholder: 'Select Time', label: 'Time',
        colSpan: 3, widget: Time, rules: [
          {
            required: true,
            message: 'Please select start date.'
          }
        ]
      }
    ]
  };


  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const emojiContent = (
    <div className={styles.popContent}>
      <div className={styles.users}>
        <KoText className={styles.words} text={'Post to peoples'} />
        <KoUserSelect mode="multiple"
          value={selectedUsers}
          onChange={(v, w,e) => { setSelectedUsers(v); console.log(v, w, e); }}
          loading={isLoading}
          users={users}
          placeholder='Select Peoples' />
      </div>
      <div className={styles.users}>
        <KoText className={styles.words} text={'Post to groups'} />
        <KoSelect mode="multiple"
          showSearch
          placeholder='Select Groups'
          loading={isLoading}
          value={selectedGroups}
          onChange={v => { setSelectedGroups(v); }}
          options={groups?.map((group) => ({
            label: group.name,
            value: group?.groupId
          }))}
        />
      </div>
    </div>
  );

  let elements=() => {
    return (
      <div className={styles.titleRight}>
        <KoText
          className={styles.words}
          text={
            selectedGroups?.length && selectedUsers?.length
              ? `Sharing with ${selectedGroups.length} group${selectedGroups.length > 1 ? 's' : ''} and ${selectedUsers.length} ${selectedUsers.length > 1 ? 'people' : 'person'}`
              : selectedGroups?.length
                ? `Sharing with ${selectedGroups.length} group${selectedGroups.length > 1 ? 's' : ''}`
                : selectedUsers?.length
                  ? `Sharing with ${selectedUsers.length} ${selectedUsers.length > 1 ? 'people' : 'person'}`
                  : 'Sharing with everyone'
          }
        />
        <div className={styles.icon}>
          <KoIcon name={'DownArrowOutlined'} width={12} height={12} />
        </div>
      </div>
    );
  };
  return (
    <div className={styles.box} >
      <div className={styles.topRow} onClick={() => setCreatePost(true)}>
        {user?.profile?.logo?.[0]?.url ? <img
          src={
            user?.profile?.logo?.[0]?.url ?? user?.profile?.logo?.[0]?.url
          }
          className={styles.avatar}
          alt="avatar"
        />: <div className={styles.avatar}>
          {user?.profile?.firstName?.charAt(0)?.toUpperCase() || ''}
          {user?.profile?.lastName?.charAt(0)?.toUpperCase() || ''}
        </div>}

        <button className={styles.inputBox}>
          Start a post
        </button>
      </div>

      <div className={styles.actions}>
        <KoButton type='text' icon={<KoIcon name={'VideoFileOutlined'} color='#4caf50'/>} label='Video' onClick={() => setCreatePost(true)} />
        <KoButton type='text' icon={<KoIcon name={'ImagesOutlined'} color='#1e88e5'/>} label='Photo' onClick={() => setCreatePost(true)} />
        <KoButton type='text' icon={<KoIcon name={'AttachmentOutlined'} color='#f44336'/>} label='Add a document' onClick={() => setCreatePost(true)} />
        {/* <KoButton type='text' icon={<KoIcon name={'PollOutlined'} color='#ff9800'/>} label='Create a Poll' onClick={() => setCreatePost(true)} />
        <KoButton type='text' icon={<KoIcon name={'IssuesOutlined'} color='#9c27b0'/>} label='Create Task' onClick={() => setCreatePost(true)} /> */}
      </div>



      <KoModal
        centered
        title={
          <KoPopOver placement="bottomLeft" className={styles.emojiPop} arrow={false} content={emojiContent}>
            <div className={styles.title}>
              <KoStaicMembers feed={true} data={user['profile']} isCustom={true} Elements={elements} />
            </div>
          </KoPopOver>
        }
        classNames={styles.modal}
        open={createPost}
        handleOk={() => { setCreatePost(false); }}
        onClose={() => { setCreatePost(false); }}
        width={'50vw'}
        footer={<div className={styles.actionsFooter}>
          <div className={`${styles.actionsCreate} modalFooter`}>
            <KoForm.Item
              name={["attachments"]}
              valuePropName={["attachments"]}
              getValueFromEvent={normFile}>
              <KoUpload
                isDnd={true}
                {...props}
                showUploadList={false}
              >
                <KoTooltips title={'Add media'}>
                  <KoButton shape='circle' type='text' icon={<KoIcon name={'ImagesOutlined'} color='#1e88e5'  width={20} height={20}/>}  />
                </KoTooltips>
              </KoUpload>
            </KoForm.Item>
            <KoForm.Item
              name={["attachments"]}
              valuePropName={["attachments"]}
              getValueFromEvent={normFile}>
              <KoUpload
                isDnd={true}
                {...props}
                showUploadList={false}
              >
                <KoTooltips title={'Add a document'}>
                  <KoButton onClick={() => setUploadFileModal(true)} shape='circle' type='text' icon={<KoIcon name={'AttachmentOutlined'} color='#f44336'  width={20} height={20}/>} />
                </KoTooltips>
              </KoUpload>
            </KoForm.Item>
            <KoTooltips title={'Create a Poll'}>
              <KoButton onClick={() => setPollModal(true)} shape='circle' type='text' icon={<KoIcon name={'PollOutlined'} color='#ff9800'  width={16} height={16}/>}  />
            </KoTooltips>
            <KoTooltips title={'Create a Issue'}>
              <KoButton shape='circle' type='text' icon={<KoIcon name={'IssuesOutlined'} color='#9c27b0'  width={20} height={20}/>} />
            </KoTooltips>
            <KoTooltips title={'Emoji'}>
              <KoButton shape='circle' type='text' icon={<KoIcon name={'SmileyOutlined'} color='#ffa940'  width={20} height={20}/>} />
            </KoTooltips>
          </div>
          <div className={styles.actionsPost}>
            <KoButton onClick={() => setOpenSchedule(true)} iconBtn={true} icon={<KoIcon name={'LogOutlined'}   width={20} height={20}/>}  key='schedule'  type='text'/>
            <KoButton key='submit' label={currentPost?.id ? 'Post' : 'Post'} type='primary' onClick={() =>form.submit()}/>
          </div>
        </div>}
      >
        <div className={styles.content}>
          {isLoading && <KoLoader />}
          <KoForm form={form} layout="vertical" onFinish={handleFinish}>
            <FeedAttachments liteBoxHide={true} attachments={form.getFieldValue('attachments')} />
            <KoFormBuilder form={form} meta={TASKINFOMETADATA} />
          </KoForm>
        </div>
      </KoModal>

      <KoModal
        title={'Upload Media'}
        centered
        open={uploadFileModal}
        afterClose={() => { setCurrentFile(); }}
        handleOk={() => { setUploadFileModal(false); }}
        onClose={() => { setUploadFileModal(false); }}
        width={760}
        footer={[
          <KoButton key='submit' label={'Done'} type='primary' onClick={() =>setUploadFileModal(false)}/>
        ]}
      >
        <div className={`${styles.uploadWrapper} customUpload`}>
          {isLoading && <KoLoader circle={false} />}
          <KoForm.Item
            name={["attachments"]}
            valuePropName={["attachments"]}
            getValueFromEvent={normFile}>
            <KoUpload
              isDnd={true}
              listType="picture"
              {...props}
            >
              <div className={styles.upload}>
                <p className="ant-upload-text">{`Click or drag file to this area to upload`} </p>
                <p className="ant-upload-hint">
                  Support for single or bulk uploads. Uploading banned files is strictly prohibited.
                </p>
              </div>
            </KoUpload>
          </KoForm.Item>
        </div>
      </KoModal>

      <KoModal
        title={'Post Poll'}
        centered
        open={isPollModal}
        afterClose={() => { setCurrentFile(); }}
        handleOk={() => { setPollModal(false); }}
        onClose={() => { setPollModal(false); }}
        width={760}
        footer={[]}
      >
        <div className={`${styles.uploadWrapper} customUpload`}>
          {isLoading && <KoLoader circle={false} />}
         asdasd
        </div>
      </KoModal>

      <KoModal
        title={'Schedule Post'}
        centered
        open={openSchedule}
        afterClose={() => { setCurrentFile(); }}
        handleOk={() => { setOpenSchedule(false); }}
        onClose={() => { setOpenSchedule(false); }}
        width={760}
        footer={[
          <KoButton key='submit' label={'Done'} type='primary' onClick={() =>scheduleForm.submit()}/>
        ]}
      >
        <div className={`${styles.uploadWrapper} customUpload`}>
          {isLoading && <KoLoader circle={false} />}
          <KoForm form={scheduleForm} layout="vertical" onFinish={handleScheduleFinish}>
            <KoFormBuilder form={scheduleForm} meta={SCHDULEDATA} />
          </KoForm>
        </div>
      </KoModal>

    </div>
  );
}
